<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">Review Budget Request</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <!-- <button pButton type="button" icon="pi pi-plus" label="Add Budget Request" iconPos="left"></button> -->
    </div>
</div>

<div class="p-white shadow m-3">
<p-table [value]="products" [autoLayout]="true"  responsiveLayout="scroll" styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        <div class="d-flex flex-row justify-content-between">
            <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text"  placeholder="Search keyword" />
            </span>
            <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th  pSortableColumn="code">Company<p-sortIcon field="code"></p-sortIcon></th>
            <th>Department</th>
            <th>Job Type</th>
            <th>Allocated Amount</th>
            <th>Allocation Type</th>
            <th>Job Category</th>
            <th>Created By</th>
            <th>Created On</th>
            <th>Status</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>labs</td>
            <td>Finance</td>
            <td>Withholding Tax </td>
            <td>20,000</td>
            <td>Yearly</td>
            <td>Payments</td>
            <td>Thushara Mahagmage</td>
            <td>2021 Aug 21</td>
            <td>
                <p-tag styleClass="me-2 mb-1" value="Pending"></p-tag>
            </td>
            <td style="text-align: right;">
                <button pButton pRipple type="button" label="Review" routerLink="/budgetRequestDetails"></button>
            </td>
        </tr>
    </ng-template>
</p-table>
</div>


